var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    ref: "wrapper"
  }, [_vm.isPreview ? [_c('div', {
    staticClass: "mb-40",
    staticStyle: {
      "height": "56px"
    }
  }, [_c('div', {
    style: _vm.style_alert
  }, [_c('v-alert', {
    staticClass: "mb-40",
    attrs: {
      "text": "",
      "icon": "mdi-information-outline",
      "color": "info",
      "rounded": ""
    }
  }, [_c('span', [_vm._v(" 미리보기 화면입니다 ")])])], 1)])] : !_vm.program.isGranted ? [_c('div', {
    staticClass: "mb-40",
    staticStyle: {
      "height": "56px"
    }
  }, [_c('div', {
    style: _vm.style_alert
  }, [_c('v-alert', {
    staticClass: "mb-40",
    attrs: {
      "text": "",
      "icon": "mdi-alert-outline",
      "color": "red",
      "rounded": ""
    }
  }, [_c('span', [_vm._v(" 승인되지 않은 프로그램입니다 ")])])], 1)])] : _vm._e(), _c('v-row', {
    staticClass: "ma-n20"
  }, [_c('v-col', {
    staticClass: "pa-20",
    attrs: {
      "order": "2",
      "order-lg": "1",
      "cols": "12",
      "lg": ""
    }
  }, [_c('view-body', _vm._b({}, 'view-body', {
    program: _vm.program,
    isPreview: _vm.isPreview
  }, false))], 1), _c('v-col', _vm._b({
    staticClass: "pa-20",
    attrs: {
      "order": "1",
      "order-lg": "2",
      "cols": "12",
      "lg": "auto"
    }
  }, 'v-col', {
    style: _vm.style_headCol
  }, false), [_c('view-head', _vm._b({}, 'view-head', {
    program: _vm.program,
    isPreview: _vm.isPreview,
    style: _vm.style_head
  }, false))], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }